import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IncidentsState} from './incidents.state';
import {incidentsFeatureKey} from './incidents.actions';

const incidentsSelector = createFeatureSelector<IncidentsState>(incidentsFeatureKey);

export const selectIncidents = createSelector(
  incidentsSelector,
  state => state.incidents
);

export const selectIncident = createSelector(
  incidentsSelector,
  state => state.selectedIncident
);

export const selectDocuments = createSelector(
  incidentsSelector,
  state => state.documents
);

export const selectComments = createSelector(
  incidentsSelector,
  state => state.comments
);
